module.exports = __webpack_public_path__ + "img/chinesecompany218.545a07e6.png";